import { HStack, Text } from '@chakra-ui/react';
import CustomTitle from '@components/common/CustomTitle';
import { useSelectorWithReplayMode } from '@hooks/useSelectorWithReplayMode';
import { selectSituationTime } from '@redux/situation/situation.selectors';
import { format } from 'date-fns';
import { FormattedMessage } from 'react-intl';

import { MapIdEnum } from '@/types/map.types';

import { useMapContext } from '../MapContext';
import MapTitleNeutral from './MapTitleNeutral';

export default function MapTitle() {
  const { mapId } = useMapContext();
  const situationTime = useSelectorWithReplayMode(selectSituationTime);
  return (
    <CustomTitle>
      <Text
        fontWeight="medium"
        textStyle="md"
        color={mapId === MapIdEnum.REPLAY ? 'skyBlue' : 'red'}
        lineClamp={1}
        userSelect="none"
      >
        <FormattedMessage id={`mapLabel.${mapId.toLowerCase()}`} />
      </Text>
      {situationTime && (
        <>
          <MapTitleNeutral />
          <HStack gap={3}>
            <HStack gap={0}>
              <Text textStyle="md" fontWeight="medium" color="neutral.200">
                {format(new Date(situationTime), 'HH:mm')}
              </Text>
              <Text textStyle="md" color="neutral.300">
                {format(new Date(situationTime), ':ss')}
              </Text>
            </HStack>
            <Text textStyle="md" color="neutral.200">
              {format(new Date(situationTime), 'dd/MM/yyyy')}
            </Text>
          </HStack>
        </>
      )}
    </CustomTitle>
  );
}
